<template>
    <div>
        <title-section title="Sube y Revisa" subtitle="TUS EXÁMENES"/>
        <v-container>
            <v-row>
                <v-col cols="12" align="right">
                    <v-btn color="primary" depressed class="normal-btn" @click="showUploadExam">
                        Subir un exámen
                    </v-btn>
                </v-col>
                <v-col cols="12">
                    <kimsa-data-table
                        :headers="headers"
                        :items="history"
                        :loading="loading"
                        @click:download="onDownload"
                        @click:edit="onEdit"
                        @click:delete="onDelete"
                    />
                </v-col>
            </v-row>
        </v-container>

        <upload-history-dialog @success="loadHistory" ref="upload"/>
        <kimsa-confirm
            ref="delete"
            title="Eliminar"
            content="¿Esta seguro que desea eliminar este exámen?"
            :loading="loadingDelete"
            @confirm="onConfirmDelete"
            persistent alert-mode
            no-close-on-confirm
        />
    </div>
</template>

<script>
import TitleSection from "@/components/common/TitleSection";
import KimsaDataTable from "@/components/common/KimsaDataTable";
import UploadHistoryDialog from "@/components/exams/UploadHistoryDialog";
import httpService from "@/services/httpService";
import KimsaConfirm from "@/components/common/KimsaConfirm";

export default {
    name: "MyExams",
    components: {KimsaConfirm, UploadHistoryDialog, KimsaDataTable, TitleSection},
    data() {
        return {
            loading: false,
            headers: [
                {text: 'Nombre', value: 'name', align: 'start'},
                {text: 'N° Orden', value: 'order_id', align: 'start'},
                {
                    buttons: [
                        {icon: 'mdi-download', value: 'download', color: 'primary'},
                        {icon: 'mdi-file-edit-outline', value: 'edit', color: 'secondary'},
                        {icon: 'mdi-delete-outline', value: 'delete', color: 'error'},
                    ],
                    value: 'buttons',
                    align: 'right'
                },
            ],
            history: [],
            loadingDelete: false,
            currentHistory: null,
        }
    },
    async mounted() {
        const vm = this
        await vm.loadHistory()
    },
    methods: {
        async loadHistory() {
            const vm = this
            vm.loading = true
            let response = await httpService.get('history')
            vm.history = response.data.history
            vm.loading = false
        },
        showUploadExam() {
            const vm = this
            vm.$refs.upload.show()
        },
        onDownload(history) {
            window.location.href = process.env.VUE_APP_BASE_URL + history.filepath
        },
        onEdit(history) {
            const vm = this
            vm.$refs.upload.loadHistory(history.id)
        },
        onDelete(history) {
            const vm = this
            vm.currentHistory = history
            vm.$refs.delete.show()
        },
        async onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true
            let response = await httpService.delete(`history/${vm.currentHistory.id}/delete`)
            vm.loadingDelete = false
            vm.toast(response.data.message)
            vm.$refs.delete.hide()
            vm.currentHistory = null
            await vm.loadHistory()
        }
    }
}
</script>

<style scoped>

</style>